// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qvMEH-QrCard-module_root{background-color:var(--bgQR);display:inline-block}.G0jDN-QrCard-module_qr{margin-bottom:1rem;width:13.3333333333rem;height:13.3333333333rem}.HPjtE-QrCard-module_logo{margin:0 auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "qvMEH-QrCard-module_root",
	"qr": "G0jDN-QrCard-module_qr",
	"logo": "HPjtE-QrCard-module_logo"
};
export default ___CSS_LOADER_EXPORT___;
